<template>
    <div class="card-body">
        <div class="form">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="managerLocal.activar_compra_por_invitacion_bases" id="activar_compra_por_invitacion_bases"/>
                    <label class="custom-control-label text-uppercase" for="activar_compra_por_invitacion_bases">Activar la inscripción  cantera por invitación con código</label>
                </div>
            </div>
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="managerLocal.documentacion_obligatoria_bases" id="documentacion_obligatoria_bases"/>
                    <label class="custom-control-label text-uppercase" for="documentacion_obligatoria_bases">La documentación del deportista será obligatoria en el proceso de compra</label>
                </div>
            </div>
            <div class="form-group">
                <label class="form-label" for="informacion">Texto de información sobre las bases:</label>
                <CkEditorComponent v-model="managerLocal.informacion_base"/>
            </div>
            <div class="form-group">
                <label class="form-label" for="informacion">Texto para las condiciones de la compra en cantera mediante plazos:</label>
                <CkEditorComponent v-model="managerLocal.condiciones_bases_plazos"/>
            </div>
            <div class="form-group">
                <label for="imagen">Imagen cantera:</label>
                <p>
                    <small>
                        MEDIDAS: 960X276 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <div class="text-center" v-if="manager.imagen_info_bases_url">
                    <template>
                        <br/>
                        <img :src="manager.imagen_info_bases_url" style="max-height: 200px"/>
                        <br/>
                        <Button class="mt-3" @click="imagenBorrada()">Borrar</Button>
                    </template>
                </div>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="276"
                        :width="960"
                        @success="imagenSubida"
                    />
                </template>
            </div>
            <div class="mt-2 text-right"> 
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import Dropzone from '@/components/common/Dropzone';
    
    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                conf: {},
                managerLocal: this.manager
            }
        },
        methods: {
            imagenBorrada() {
                this.managerLocal.imagen_info_bases = null;
                this.managerLocal.imagen_info_bases_url = null;
            },
            imagenSubida(file, response) {
                this.managerLocal.imagen_info_bases = response;
            },
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            }
        },
        components: { CkEditorComponent, Dropzone }
    }
</script>